import React from 'react';
import Galleries from '../components/gallery/Galleries';

const GalleryManagement: React.FC = () => {
  return <Galleries />;
};

export default GalleryManagement;
